import {
  ChangeDetectionStrategy,
  Component,
  EventEmitter,
  Input,
  OnInit,
  Output,
} from '@angular/core';

import { THEME } from '@lib/ui/theme';

@Component({
  selector: 'fs-ai-boxes',
  templateUrl: './ai-boxes.component.html',
  styleUrls: ['./ai-boxes.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class AiBoxesComponent implements OnInit {
  @Input() public detections = [];
  @Input() public resolution: any = {};

  @Output() public readonly mouseOver = new EventEmitter();

  @Output() public readonly clickItem = new EventEmitter();

  // eslint-disable-next-line @angular-eslint/no-output-native
  @Output() public readonly select = new EventEmitter();

  public item: any;

  constructor() {}

  public ngOnInit(): void {}

  public getStyle(item: any): any {
    return {
      position: 'absolute',
      top: `${(item.box.startY / this.resolution.height) * 100}%`,
      left: `${(item.box.startX / this.resolution.width) * 100}%`,
      width: `${(item.box.width / this.resolution.width) * 100}%`,
      height: `${(item.box.height / this.resolution.height) * 100}%`,
      border: `2px solid ${item.detectionId === this.item?.detectionId ? THEME.success : 'red'}`,
    };
  }

  public onMouseOver(item: any): void {
    this.item = item;
    this.mouseOver.emit(item);
  }
  public onClick(item: any): void {
    this.item = item;
    this.clickItem.emit(item);
  }

  public onSelect(item: any): void {
    this.select.emit(item);
  }
}
